import React, { useState, useEffect } from "react";
import axios from "axios";
import StatusView from "../subs/StatusView.js";
import WebpageNotAvailable from "../subs/WebpageNotAvailable.js";

const Main = ({ hostURL, resURL }) => {
  const [currentState,setCurrentState] = useState({
    data_retrieved: false,
    data_placeholder: <h2 style={{fontWeight: '400', fontSize: '1rem', color: 'rgb(12, 89, 127)'}}>
      wait, the data is still fetching
      <span>&nbsp;&nbsp;</span>
      <i className="fa-solid fa-arrows-rotate"></i>
    </h2>
  });
  
  useEffect(() => {
    const WPNA = <WebpageNotAvailable
      img={"broken_url"}
      info={"web page is not available"}
    />

    axios.get(`${hostURL}`)
    .then(res => {
      if(typeof(res.data)!=="string") {
        setCurrentState({
          ...currentState,
          data_retrieved: true,
          data_placeholder: <StatusView baseURL={hostURL} res_URL={resURL}/>
        });
      }
    })
    .catch(err => {
      setCurrentState({
        ...currentState,
        data_retrieved: true,
        data_placeholder: WPNA
      });
      console.log(`[Fetch${err.name}]: ${err.code} [Status]: ${err.request.status}`);
    });
  }, [currentState,hostURL,resURL]);

  return (
    <main>
      {currentState.data_placeholder}
    </main>
  );
}

export default Main;